
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { OrderModel } from './Entities.GormCrm.Order';
import { PlanReplacementNewPlanModel } from './Entities.GormCrm.PlanReplacementNewPlan';
import { PlanReplacementOldPlanModel } from './Entities.GormCrm.PlanReplacementOldPlan';
import { Model, ModelProperty } from 'models/Model';


export class PlanReplacementModel extends Model<PlanReplacementModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'guid', languageString: 'planReplacement.property.id', isHidden: true },
		{ name: 'orderId', type: 'guid', languageString: 'planReplacement.property.orderId' },
		{ name: 'created', type: 'Date', languageString: 'planReplacement.property.created', isHidden: true },
		{ name: 'delivered', type: 'Date', languageString: 'planReplacement.property.delivered' },
		{ name: 'order', type: 'OrderModel', languageString: 'planReplacement.property.order', isHidden: true, isObject: true, new: () => { return new OrderModel }, properties: () => { return OrderModel.classProperties } },
		{ name: 'planReplacementNewPlans', type: 'PlanReplacementNewPlanModel[]', languageString: 'planReplacement.property.planReplacementNewPlans', isHidden: true, isArray: true, isObject: true, new: () => { return new PlanReplacementNewPlanModel }, properties: () => { return PlanReplacementNewPlanModel.classProperties } },
		{ name: 'planReplacementOldPlans', type: 'PlanReplacementOldPlanModel[]', languageString: 'planReplacement.property.planReplacementOldPlans', isHidden: true, isArray: true, isObject: true, new: () => { return new PlanReplacementOldPlanModel }, properties: () => { return PlanReplacementOldPlanModel.classProperties } }
	];
	[key: string]: any;
	
	public id?: string;
	public orderId?: string;
	public created?: Date;
	public delivered?: Date;
	public order?: OrderModel;
	public planReplacementNewPlans: PlanReplacementNewPlanModel[];
	public planReplacementOldPlans: PlanReplacementOldPlanModel[];
    
	constructor(){
		super();
		this.id = undefined;
		this.orderId = undefined;
		this.created = undefined;
		this.delivered = undefined;
		this.order = undefined;
		this.planReplacementNewPlans = [];
		this.planReplacementOldPlans = [];
		
	}
	getProperties(){
		return PlanReplacementModel.classProperties;
	}
}

